import { observer } from 'mobx-react-lite'
import { Status } from 'shared/ui'
import { type KnowledgeBaseDocumentStatus } from 'entities/KnowledgeBase'
import { getKnowledgeBaseDocumentStatusConfig } from 'widgets/KnowledgeBase/lib/getKnowledgeBaseDocumentStatusConfig'

type KnowledgeBaseDocumentStatusLabelProps = {
  status: KnowledgeBaseDocumentStatus
  isLiveDocument?: boolean
  className?: string
}

export const KnowledgeBaseDocumentStatusLabel = observer(
  ({ status, isLiveDocument, className }: KnowledgeBaseDocumentStatusLabelProps) => {
    const config = getKnowledgeBaseDocumentStatusConfig(status, isLiveDocument)

    if (!config) return null

    return <Status {...config} className={className} />
  }
)
